import { Outlet } from "react-router-dom";

function PublicRouteComponent() {
  return (
    <div className="App">
      <Outlet />
    </div>
  );
}

export default PublicRouteComponent;
